exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scroll-indicator{position:fixed;bottom:0;left:0;width:100vw;z-index:90;overflow:hidden;display:flex;justify-content:center;opacity:0}.scroll-indicator .indicator{text-align:center;margin-bottom:60px;opacity:.5}.scroll-indicator .indicator p{font-size:12px;font-family:Saira Extra Condensed,sans-serif;font-weight:300;color:#fff;text-transform:uppercase;margin-bottom:24px;letter-spacing:.15em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-444eb39c","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/partials/scroll-indicator.vue
// module id = 385
// module chunks = 0